export default {"src":"/_next/static/media/hulu.8b3cf587.svg","height":41,"width":40};